import { init, setTag, withScope, captureMessage, captureException } from '@sentry/react';
import config, { ENV_NAME } from 'config/config';

import { SENTRY_OPTIONS, LOGLEVEL } from '../constants/sentry.constants';

export function initializeSentry({ module }) {
  if (config && config.env === ENV_NAME.PROD) {
    init({
      ...SENTRY_OPTIONS,
      beforeSend(event, hint) {
        const error = hint.originalException;
        if (error && error.message && error.message.match(/Request failed with status code|Network Error|Unknown API error occured./i)) {
          event.level = LOGLEVEL.info;
        }
        return event;
      },
      beforeBreadcrumb(breadcrumb, hint) {
        if (breadcrumb.category === 'xhr') {
          // hint.xhr is a whole XHR object that can be used to modify breadcrumb
        }
        return breadcrumb;
      }
    });

    // set module tag
    setTag('module', module);
  }
}

export function serializeError(err) {
  // return JSON.parse(JSON.stringify(err, Object.getOwnPropertyNames(err)))
  return Object.getOwnPropertyNames(err).reduce((acc, key) => {
    acc[key] = err[key];
    return acc;
  }, {});
}

export function logToSentry(errorMsg, errorException, xhrLog = false, logLevel) {
  if (!errorMsg) {
    return false;
  }

  if (errorMsg) {
    withScope((scope) => {
      const sentryLogLevel = logLevel || LOGLEVEL.info;

      scope?.setLevel(sentryLogLevel);

      if (errorException) {
        if (xhrLog) {
          const { status, responseURL } = errorException?.response?.request;

          if ((status >= 400 && status <= 599) || errorException?.apiInternalError) {
            const message = `${errorMsg} -> ${responseURL} -> ${status}`;
            const additionalInfo = serializeError(errorException);

            captureMessage(message, { extra: additionalInfo });
          }
        } else {
          captureException(errorException);
        }
      } else {
        captureMessage(errorMsg);
      }
    });
  }
}
